import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import CustomerService from './CustomerService';

const CustomerServiceScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  
  return (
    <PageContent title={t('salesPerformance:CustomerService')}>
      <CustomerService />
    </PageContent>
  )
}

export default CustomerServiceScreen;